document.addEventListener("DOMContentLoaded", function () {
    let pathname = window.location.pathname
        .replace("/404", "")
        .replace(".html", "")
        .replaceAll("/", "")
        .replace("products", "")
        .trim();

    if (pathname) {
        let words = pathname.split("-").slice(0, 4);
        let searchQuery = words.join(" ");

        if (searchQuery) {
            let searchTitle = document.getElementById("search-title");

            // Properly sets the href so the title is clickable
            searchTitle.innerHTML = `Try searching for: 
                <a class="btn btn--has-icon-after" href="/search?q=${encodeURIComponent(searchQuery)}">
                    <strong>${searchQuery}</strong>
                </a>`;

            let searchUrl = `/search/suggest.json?q=${encodeURIComponent(searchQuery)}&resources[type]=product`;

            fetch(searchUrl)
                .then(response => response.json())
                .then(data => {
                    let productResults = document.getElementById("product-results");
                    document.getElementById("loading-message").style.display = "none";
                    productResults.innerHTML = "";

                    if (data.resources.results.products.length > 0) {
                        data.resources.results.products.forEach(product => {
                            let li = document.createElement("li");
                            let link = document.createElement("a");
                            link.href = product.url;
                            link.innerHTML = `<strong>${product.title}</strong>`;
                            li.appendChild(link);
                            productResults.appendChild(li);
                        });
                    } else {
                        productResults.innerHTML = "<li><strong>No matching products found. Try searching manually.</strong></li>";
                    }
                })
                .catch(() => {
                    document.getElementById("loading-message").innerHTML = "<strong>Error loading products.</strong>";
                });
        }
    } else {
        document.getElementById("search-title").innerHTML = `Try browsing our 
            <a href='/collections/all' class="btn btn--has-icon-after">
                <strong>products</strong>
            </a>.`;
        document.getElementById("loading-message").style.display = "none";
    }
});
